// extracted by mini-css-extract-plugin
export default {"root":"ReportsTable_root__9FmD5","EmptyRow":"ReportsTable_EmptyRow__iFJtb","dataLoadingWrap":"ReportsTable_dataLoadingWrap__toJnt"};